<template>
  <div>
    <list
      ref="refLaboralFunctionList"
      sort-by="FuncionLaboralId"
      :refetch-records="fetchLaboralFunctions"
      refetch-records-name="funcionesLaborales"
      :actions="actions"
      key-field="funcionLaboralId"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :delete-method="deleteLaboralFunction"
      :filters.sync="filters"
    />
  </div>
</template>
<script>

import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import List from '@/components/List.vue'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    List,
  },
  setup() {
    /* Refs */
    const refLaboralFunctionList = ref(null)
    /* Services */
    const {
      fetchLaboralFunctions,
      deleteLaboralFunction,
    } = humanResources()
    /* Data */
    const tableColumns = [
      {
        label: i18n.t('humanResources.laboralFunction.columns.name'),
        key: 'nombre',
      },
      {
        label: i18n.t('humanResources.laboralFunction.columns.description'),
        key: 'descripcion',
      },
      {
        label: i18n.t('humanResources.laboralFunction.columns.indicator'),
        key: 'indicador',
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Edit'),
        aclAction: 'create',
        aclResource: 'FormacionAcademica',
        routeName: 'apps-human-resources-laboral-function-edit',
        params: ['funcionLaboralId'],
        icon: 'CodepenIcon',
      },
      {
        name: 'delete',
        label: i18n.t('Lists.Delete'),
        aclAction: 'delete',
        aclResource: 'FormacionAcademica',
        params: ['funcionLaboralId'],
        icon: 'TrashIcon',
      },
    ])
    const actions = ref([
      {
        routeName: 'apps-human-resources-laboral-function-add',
        label: i18n.t('Routes.LaboralFunctionAdd'),
        aclAction: 'create',
        aclResource: 'FormacionAcademica',
        icon: 'PlusCircleIcon',
      },
    ])
    const filters = ref([])
    return {
      refLaboralFunctionList,
      tableColumns,
      tableActions,
      actions,
      filters,
      fetchLaboralFunctions,
      deleteLaboralFunction,
    }
  },
}
</script>
